import { API, graphqlOperation } from "aws-amplify";
import * as subscriptions from "../../graphql/subscriptions";

class OrgAdminUserSubscription {
  /*
    Task: Get OrgAdminUser subscription on create from amplify graphql
  */
  static getOnCreate() {
    return API.graphql({
      ...graphqlOperation(subscriptions.onCreateOrgAdminUser),
      authMode: "AMAZON_COGNITO_USER_POOLS",
    }) as any;
  }

  /*
    Task: Get OrgAdminUser subscription on update from amplify graphql
  */
  static getOnUpdate() {
    return API.graphql({
      ...graphqlOperation(subscriptions.onUpdateOrgAdminUser),
      authMode: "AMAZON_COGNITO_USER_POOLS",
    }) as any;
  }

  /*
    Task: Get OrgAdminUser subscription on delete from amplify graphql
  */
  static getOnDelete() {
    return API.graphql({
      ...graphqlOperation(subscriptions.onDeleteOrgAdminUser),
      authMode: "AMAZON_COGNITO_USER_POOLS",
    }) as any;
  }
}

export { OrgAdminUserSubscription };
